import React, { useState } from 'react';
import { DescriptionOutlined } from '@material-ui/icons';
import ImageMetaData from '../../../../../common/ProImages/components/Popup/components/ImageMetaData';
import StyledToolTip from '../../../../../common/StyledToolTip';
import { CircularProgress } from '@material-ui/core';
import { postData } from '../../../../../../api/componentAPIs';
import { withSnackbar } from 'notistack';

const getDeliveryReceiptList = (items, imageURLDetailsByTimestamp) => {
  return items
    .map(({ key, blobData }) => ({
      key,
      blobData,
      ...imageURLDetailsByTimestamp[key]
    }))
    .sort((x, y) => y.key - x.key);
};

const DeliveryReceiptList = ({
  items,
  label,
  classes,
  openEDR,
  enablePublishDeliveryReceiptFromReport,
  imageURLDetailsByTimestamp,
  proReceiverDetails,
  enqueueSnackbar,
}) => {
  const [sendEDRLoader, setSendEDRLoader] = useState(null);
  const deliveryReceiptList = getDeliveryReceiptList(items, imageURLDetailsByTimestamp);

  const sendEDR = (e, deliveryReceipt) => {
    e.stopPropagation();
    setSendEDRLoader(deliveryReceipt.file);
    const data = {
      terminalCode: proReceiverDetails.terminalCode,
      routeId: proReceiverDetails.routeId,
      proNumber: `${deliveryReceipt.file}`, // proNumber with all suffixes attached to file name
      receiverName: proReceiverDetails?.name || null,
      receiverPhoneNumber: proReceiverDetails?.contact || null, //optional
      receiverEmail: proReceiverDetails?.email || null //optional
    };
    postData('PublishDeliveryReceipt', data).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          setSendEDRLoader(null);
          enqueueSnackbar('Delivery receipt published successfully', {
            variant: 'success'
          });
        } else {
          handleSendEDRError(response);
        }
      },
      () => {
        handleSendEDRError();
      }
    );
  };

  const handleSendEDRError = (response) => {
    setSendEDRLoader(null);
    if (response?.statusCode === 403) {
      return;
    }
    const errorMessage = response?.response?.data?.error?.message || response?.message;
    enqueueSnackbar(
      errorMessage ||
      'An error occurred while publishing delivery receipt. Please try again later.',
      { variant: 'error' }
    );
  };

  return (
    <>
      <div className={classes.label}>{label}</div>
      <div className={classes.edrContainer}>
        {deliveryReceiptList.map((deliveryReceipt, index) => (
          <div key={deliveryReceipt?.timestamp ?? index} className={classes.edRBox}>
            <ImageMetaData
              date={deliveryReceipt?.date}
              time={deliveryReceipt?.time}
              address={deliveryReceipt?.address}
              isEDR={true}
            >
              <div
                className={classes.eDRPlaceholderContainer}
                onClick={() => openEDR(deliveryReceipt)}
              >
                {enablePublishDeliveryReceiptFromReport && proReceiverDetails && (
                  <div className={classes.edrActions}>
                    {sendEDRLoader === deliveryReceipt.file ? (
                      <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
                    ) : (
                      <StyledToolTip title="Send e-DR to AS400">
                        <i
                          className={`${classes.actionIcon} icon-icon_upload`}
                          onClick={(e) => sendEDR(e, deliveryReceipt)}
                        />
                      </StyledToolTip>
                    )}
                  </div>
                )}
                <DescriptionOutlined className={classes.descriptionIcon} fontSize="large" />
              </div>
            </ImageMetaData>
          </div>
        ))}
      </div>
    </>
  );
};

export default withSnackbar(DeliveryReceiptList);
